module.exports = __webpack_public_path__ + "img/stocks-iq.09697744.png";